import { render, staticRenderFns } from "./customervendorselector.vue?vue&type=template&id=03ca51c4"
import script from "./customervendorselector.vue?vue&type=script&lang=js"
export * from "./customervendorselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports